module.exports = __webpack_public_path__ + "img/bg.872625d2.png";